export function authHeader () {
    let token = JSON.parse(localStorage.getItem('token'))

    if (token && token.token) {
        return { 'Authorization': 'Bearer ' + token.token, 'Content-Type': 'application/json' }
    } else {
        return {}
    }
}

export function noContentTypeHeader () {
    let token = JSON.parse(localStorage.getItem('token'))

    if (token && token.token) {
        return { 'Authorization': 'Bearer ' + token.token }
    } else {
        return {}
    }
}

export function bdltAuthHeader () {
    let token = JSON.parse(localStorage.getItem('bdlttoken'))

    if (token && token.accessToken) {
        return { 'Authorization': token.accessToken, 'Content-Type': 'application/json' }
    } else {
        return {}
    }
}
